import { store } from 'redux/store';
import { setShow } from 'redux/reducers/sendInvoiceModalReducer';

export default function onModalHide() {
  store.dispatch(setShow(false));
}
